import HistoryContextComponent from './../../components/HistoryContextComponent/index';

import WebSQL from '../WebSQL';
import IndexedDB from './../IndexedDB/index';

const DatabaseInfo = {
    dbName: 'db',
    version: '1.0',
    name: 'sqllite stations database',
    size: 2 * 1024 * 1024,
    access: 'readwrite',
    type: 'IndexedDB'
};

const Table = {
    stationsTable: "stations"
};

const Columns = {
    stationsColumns: ['id', 'name', 'station_id', 'sound', 'products', 'longitude', 'latitude', 'searched', 'favorite']
};

const getDatabase = () => {
    switch (DatabaseInfo.type) {
        case 'WebSQL': return new WebSQL();
        case 'IndexedDB': return new IndexedDB();
        default: break;
    }
}

var database = getDatabase()

class DatabaseInterface extends HistoryContextComponent {
    // fetchNearbyStations(table, latitude, longitude) {
    //     let lat = parseFloat(latitude) * 1000000;
    //     let long = parseFloat(longitude) * 1000000;
    //     let columns = ["latitude", "longitude", "latitude", "longitude"];
    //     let delta = 50000;
    //     let minLat = parseInt((lat - delta), 10);
    //     let maxLat = parseInt((lat + delta), 10);
    //     let minLong = parseInt((long - delta), 10);
    //     let maxLong = parseInt((long + delta), 10);
    //     let values = [minLat.toString(), minLong.toString(), maxLat.toString(), maxLong.toString()];
    //     let operators = [">", ">", "<", "<"];

    //     return database.fetch(table, columns, values, operators);
    // }

    getSpecificData(table, column, values) {
        return database.fetchSpecificData(table, column, values);
    }

    insert(table, values, columns) {
        return database.insert(table, values, columns);
    }

    update(table, statement, values, station) {
        return database.update(table, statement, values, station);
    }

    // delete(table, callback) {
    //     database.dropTable(table, callback);
    // }

    // search(table, column, values) {
    //     return database.search(table, column, values);
    // }

    count(table) {
        return database.checkTableRowsCount(table);
    }
    
    query(statement, callback) {
        database.query(statement, callback);
    }
}

export { DatabaseInterface, DatabaseInfo, Table, Columns };
